module.exports = __webpack_public_path__ + "files/cateau.4dfff1e4c3766f32966c327aea6393ef.pdf";